import styled from '@emotion/styled';
import { BreakpointValue } from 'consts/breakpoints';
import { colorToAlpha } from 'helpers/insight';

export const rangeToGalleryHeight: Record<BreakpointValue, number> = {
  1: 195,
  2: 353,
  3: 393,
  4: 520,
  5: 520,
};

export const GalleryWrapper = styled.div`
  position: relative;
  width: 100%;
  direction: ltr;
`;

export const SliderItemContainer = styled.div<{}>`
  ${({ theme }) => Object.keys(rangeToGalleryHeight).map(key => (
    theme.media.showAt({ at: (+key as BreakpointValue) })`
      height: ${rangeToGalleryHeight[key]}px;
    `
  ))};
  position: relative;
  flex-grow: 1;
  & > div {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    & > img {
      object-fit: contain;
    }
  }
`;

export const ImageInfoRoot = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 2 })`
    background-color: ${colorToAlpha(theme.colors.neutrals.white, 0.85)};
    padding: ${theme.spacing(1)} ${theme.spacing(2.5)};
    direction: rtl;
    position: absolute;
    bottom: 2.5px;
    left: 24px;
    color: ${theme.colors.neutrals.grey1};

    > a {
      text-decoration: none;
      color: ${theme.colors.brand.main};
      &:hover {
        color: ${theme.colors.brand.dark};
        text-decoration: underline;
      }
      &:active {
        color: ${theme.colors.brand.darker};
      }
    }
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    padding: ${theme.spacing(1)} 0;
    border-bottom: 1px solid ${theme.colors.neutrals.grey8};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.neutrals.grey1};

    > a {
      color: ${theme.colors.brand.main};
      &:active {
        color: ${theme.colors.brand.darker};
      }
    }
  `}
`;
